import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LegalPage({ title, sections }) {
  return (
    <div className="bg-slate-50 min-h-screen flex flex-col" data-testid="legal-page">
      <Navbar />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 py-20 sm:py-24">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
            ACS Corporate
          </p>
          <h1
            className="mt-4 font-sans font-extrabold text-slate-900 text-3xl sm:text-4xl tracking-tight"
            data-testid="legal-title"
          >
            {title}
          </h1>
          <div className="mt-12 space-y-10">
            {sections.map((s) => (
              <section key={s.h2}>
                <h2 className="font-sans font-bold text-slate-900 text-xl">{s.h2}</h2>
                <div className="mt-4 space-y-3 text-base text-slate-800 leading-relaxed">
                  {s.paragraphs.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
